import _get from 'lodash.get';
import { TOI_IMAGE_DOMAIN, FREE_ARTICLE_PRIME_ID } from '../../constants';

const htmltagsRegex = /(<([^>]+)>)/gi;

const removeSpecialChar = txt => {
  if (txt && typeof txt === 'string') {
    txt.replace(/"/, '');
  } else {
    txt = '';
  }
  return txt;
};

const getWebPageSchema = data => {
  const webPageSchema = {
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name: data && data.hl ? removeSpecialChar(data.hl) : '',
    url: data?.articleShowSchemaUrl || data?.wu || '',
  };
  return webPageSchema;
};

const articleType = {
  TYPE: 'Article',
  MSIDS: ['64474452', '2886724', '61359171', '46551404'],
};
const newsArticleType = {
  TYPE: 'NewsArticle',
  MSIDS: ['64945139'],
  IGNORE_VAL: 'ignore newsarticle',
  INTL_US_MSID: '72258322',
  ARTICLE_BODY_SECTIONS: {
    SUBSEC1: ['296589292'],
    SUBSEC2: ['9978101'],
  },
};

const getArticleshowBody = data => {
  let body = '';
  if (data && Array.isArray(data.story) && data.story.length > 0) {
    data.story.forEach(item => {
      if (
        !(
          item.type === 'cdata' &&
          (item.subType === 'instagram' ||
            item.subType === 'reels-instagram' ||
            item.subType === 'twitter')
        ) &&
        !(
          item.type === 'inlinevideo' ||
          item.type === 'inlineimage' ||
          item.type === 'article'
        ) &&
        item.value
      ) {
        body += item.value;
      }
    });
  }

  body = body.replace(htmltagsRegex, '');

  return body;
};

const getArticleSchemaType = data => {
  let type;
  const eventName = _get(data, 'metaInfo.EventName', '');
  const altDescription = _get(data, 'metaInfo.Altdescription', '');
  // Checking if meta-data eventName is being defined to have the Article Schema first
  if (eventName && eventName === articleType.TYPE) {
    type = articleType.TYPE;
  }

  const { navsubsecs = {} } = data;
  if (navsubsecs) {
    const subsec3 = _get(navsubsecs, 'subsec3.subsecmsid3', '');
    const subsec2 = _get(navsubsecs, 'subsec3.subsecmsid2', '');

    if (subsec3) {
      if (newsArticleType.MSIDS.indexOf(subsec3) !== -1) {
        type = newsArticleType.TYPE;
      } else if (articleType.MSIDS.indexOf(subsec3) !== -1) {
        type = articleType.TYPE;
      }
    } else if (subsec2 && articleType.MSIDS.indexOf(subsec2) !== -1) {
      type = articleType.TYPE;
    }
    if (!type && altDescription !== newsArticleType.IGNORE_VAL) {
      type = newsArticleType.TYPE;
    }
    return type;
  }

  return type;
};

const getAuthorDetails = data => {
  if (data && Array.isArray(data.au) && data.au.length > 0) {
    return data.au.map(value => value.value).join(',');
  } else if (data && Array.isArray(data.authors) && data.authors.length > 0) {
    return data.authors.map(value => value.name).join(',');
  }
  return undefined;
};

const getNewsArticleSchema = (articleData = {}, seoData = {}, params = {}) => {
  const articlebody = getArticleshowBody(articleData);
  const type = getArticleSchemaType(articleData);
  if (type) {
    const author = getAuthorDetails(articleData);

    let img =
      Array.isArray(articleData.images) && articleData.images.length > 0
        ? articleData.images[0].id
        : '';
    if (!img) {
      img =
        articleData && articleData.imageid
          ? articleData.imageid.split('&')[0]
          : '47529300';
    }

    const { navsubsecs = {} } = articleData;
    // const subsec3 = _get(navsubsecs, 'subsec3.subsecmsid3', '');
    // const isUsSubsecMsid = subsec3 === newsArticleType.INTL_US_MSID;
    const defaultAuthor =
      articleData && articleData.ag ? articleData.ag : 'The Times Of India';
    const authorObj = {
      '@type': author ? 'Person' : 'Thing',
      name: author || defaultAuthor,
    };
    if (
      articleData &&
      Array.isArray(articleData.authors) &&
      articleData.authors.length > 0 &&
      articleData.authors[0].wu
    ) {
      authorObj.url = articleData.authors[0].wu;
    }
    let resizeMode6 = 6;
    let resizeMode4 = 4;
    const seolocation1 = _get(navsubsecs, 'subsec1.seolocation1', '');
    if (seolocation1 === 'city') {
      resizeMode6 = 72;
      resizeMode4 = 72;
    }
    const imageHeight = 720;
    const imageWidth = 1280;

    const mainEntityOfPageUrl =
      seoData && seoData.canonical ? seoData.canonical : articleData.wu;

    let returnArticleSchema = {
      '@context': 'https://schema.org',
      articleBody: articlebody,
      '@type': type,
      mainEntityOfPage: mainEntityOfPageUrl,
      inLanguage: 'en', // @check for the meta if being picked
      headline: articleData.hl ? removeSpecialChar(articleData.hl) : '',
      keywords: seoData.keywords || '',
      url: articleData.wu || '',
      datePublished: seoData.datePublished || '',
      dateModified: seoData.dateModified || '',
      description: seoData.description || '',
      thumbnailUrl:
        Array.isArray(articleData.images) && articleData.images.length > 0
          ? `${TOI_IMAGE_DOMAIN}/thumb/msid-${
              articleData.images[0].id
            },width-1280,height-720,imgsize-${
              articleData.images[0].imagesize
            },resizemode-${resizeMode6},overlay-toi_sw,pt-32,y_pad-40/photo.jpg`
          : `${TOI_IMAGE_DOMAIN}/photo/msid-47529300/47529300.jpg`,

      author: authorObj,
      publisher: {
        '@type': 'Organization',
        name: 'The Times Of India',
        url: `https://timesofindia.indiatimes.com/`,
        logo: {
          '@type': 'ImageObject',
          url: `${TOI_IMAGE_DOMAIN}/photo/msid-92877370/92877370.jpg`,
          width: 600,
          height: 60,
        },
      },
      image: {
        '@type': 'ImageObject',
        url: `${TOI_IMAGE_DOMAIN}/thumb/resizemode-${resizeMode4},width-${imageWidth},height-${imageHeight},msid-${img}/${img}.jpg`,
        width: imageWidth,
        height: imageHeight,
      },
    };
    if (articleData?.primeid || params?.isPrime) {
      const hasPartData = {
        '@type': 'WebPageElement',
        isAccessibleForFree: articleData?.primeid
          ? articleData?.primeid === FREE_ARTICLE_PRIME_ID
          : true,
        cssSelector: '.paywall',
      };
      returnArticleSchema = {
        ...returnArticleSchema,
        isAccessibleForFree: articleData?.primeid
          ? articleData?.primeid === FREE_ARTICLE_PRIME_ID
          : true,
        isPartOf: {
          '@type': ['CreativeWork', 'Product'],
          name: 'The Times of india',
          productID: 'timesofindia.com:showcase',
        },
      };
      if (articleData?.primeid) {
        returnArticleSchema.hasPart = hasPartData;
      }
    }
    return returnArticleSchema;
  }
  return {};
};

const getViewActionSchema = seoData => {
  const deeplinkPath = seoData && seoData.deeplink && seoData.deeplink.android;
  if (deeplinkPath) {
    return {
      '@context': 'https://schema.org/',
      '@type': 'ViewAction',
      target: {
        type: 'EntryPoint',
        urlTemplate: deeplinkPath,
      },
    };
  }
  return {};
};

const generateArticleshowSchema = (articleData, seoData, params) => {
  const schema = [];
  const webPageSchema = JSON.stringify(getWebPageSchema(articleData));
  schema.push(webPageSchema);
  const newsArticleSchema = JSON.stringify(
    getNewsArticleSchema(articleData, seoData, params),
  );
  schema.push(newsArticleSchema);

  const viewActionSchema = JSON.stringify(getViewActionSchema(seoData));
  schema.push(viewActionSchema);

  return schema;
};

export default generateArticleshowSchema;
